<template>
    <AllowPermission :permission="`VIEW_${permissionCategory}`">
        <div>
            <AllowPermission :permission="`CREATE_${permissionCategory}`">
                <div class="crud-section-header" v-if="createUrl && !onlyEdit && !onlyCreate">
                    <h3 class="crud-page-title">{{ title }}</h3>
                    <button class="crud-add-btn" @click="enableCreateForm">
                        <i :class="showForm && !editMode ? 'fas fa-minus' : 'fas fa-plus'"></i>
                        {{ showForm && !editMode ? 'Close' : 'Add ' + title }}
                    </button>
                </div>
            </AllowPermission>

            <div v-if="showForm || onlyCreate">
                <Form
                    :fields="createFields"
                    :onlyCreate="onlyCreate"
                    :title="title"
                    :submitUrl="createUrl"
                    :updateRootUrl="updateRootUrl"
                    @success="handleCreateSuccess"
                    @formDataUpdated="$emit('formDataUpdated', $event)"
                    @cancel="disableEditing(true)"
                    :editMode="editMode"
                    :editData="editData"
                />
            </div>
            <div v-if="loading && !onlyCreate" class="crud-loading">
                <div class="crud-spinner"></div>
            </div>
            <div class="crud-empty-state" v-if="!onlyEdit && !onlyCreate && !loading && !dataItems.length">
                <i class="fas fa-inbox"></i>
                <p>No {{ title || 'data' }} found</p>
            </div>
            <div v-else class="datatable-wrapper">
                <datatable
                    :title="`${title} data`"
                    :columns="columns"
                    :rows="dataItemFilter(dataItems)"
                    :exactSearch="false"
                    v-if="!onlyEdit && !onlyCreate && dataItems.length"
                >
                    <th slot="thead-tr">Actions</th>
                    <template slot="tbody-tr" slot-scope="props">
                        <td>
                            <div class="crud-action-group">
                                <slot :itemId="props.row.id" />
                                <AllowPermission :permission="`EDIT_${permissionCategory}`">
                                    <button
                                        class="crud-action-btn crud-btn-edit"
                                        v-if="editRouteName"
                                        @click="
                                            navigatePage({
                                                name: editRouteName,
                                                params: { id: props.row.id },
                                            })
                                        "
                                    >
                                        <i class="fas fa-pen"></i> {{ editBtnName }}
                                    </button>
                                    <button
                                        class="crud-action-btn crud-btn-edit"
                                        v-else-if="allowEditing"
                                        @click="enableEditing(dataItems.find((item) => item.id == props.row.id))"
                                    >
                                        <i class="fas fa-pen"></i> {{ editBtnName }}
                                    </button>
                                </AllowPermission>
                                <AllowPermission :permission="`DELETE_${permissionCategory}`">
                                    <button
                                        class="crud-action-btn crud-btn-delete"
                                        v-if="deleteRootUrl"
                                        @click="deleteDataItem(props.row.id)"
                                    >
                                        <i class="fas fa-trash-alt"></i> Delete
                                    </button>
                                </AllowPermission>
                            </div>
                        </td>
                    </template>
                </datatable>
            </div>
        </div>
    </AllowPermission>
</template>

<script>
import "material-design-icons-iconfont"
import Card from "../../components/UI/Card.vue"
import Button from "../../components/UI/Button.vue"
import Form from "../../components/crud/form.vue"
import { http } from "../../utils/http"
import "vue-good-table/dist/vue-good-table.css"
// import { VueGoodTable } from 'vue-good-table';
import DataTable from "vue-materialize-datatable"
import AllowPermission from "../layout/AllowPermission.vue"

export default {
    emits: ["created", "formDataUpdated"],
    components: { Form, Card, Button, datatable: DataTable, AllowPermission },
    data() {
        return {
            dataItems: [],
            name: "",
            showForm: false,
            initialized: false,
            processing: false,
            columns: [],
            loading: false,
            editMode: false,
            editData: null,
        }
    },
    props: {
        // below two fields are required to apply permissions
        editBtnName: {
            type: String,
            default: "Edit",
        },
        permission: {
            type: String,
            default: "",
        },
        applyPermissions: {
            type: Boolean,
            default: true,
        },

        onlyCreate: {
            type: Boolean,
            default: false,
        },
        allowEditing: {
            type: Boolean,
            default: true,
        },
        backRoute: {
            type: String,
            default: "",
        },
        editingFormatter: {
            type: Function,
            default: (data) => {
                return data
            },
        },
        dataItemFilter: {
            type: Function,
            default: (data) => {
                return data
            },
        },
        allowGoBack: {
            type: Boolean,
            default: false,
        },
        onlyEdit: {
            type: Boolean,
            default: false,
        },
        onlyEditData: {
            type: Object,
            default: () => null,
        },
        editRouteName: { type: String, default: "" },
        createFields: {
            type: Array,
            default: () => [],
        },
        title: {
            type: String,
            default: "",
        },
        fetchUrl: {
            type: String,
            default: "",
        },
        createUrl: {
            type: String,
            defualt: "",
        },
        updateRootUrl: {
            type: String,
            defualt: "",
        },
        deleteRootUrl: {
            type: String,
            default: "",
        },
        reloadOnSuccess: {
            type: Boolean,
            default: false,
        },
        viewColumns: {
            type: Array,
            default: () => [
                // {
                //     label: "Id",
                //     field: "id",
                //     type: "number",
                // },
                // {
                //     label: "Name",
                //     field: "name",
                // },
            ],
        },
    },
    computed: {
        permissionCategory() {
            // get the rest of the permissions
            const prmCat = this.permission ? this.permission.split("_").slice(1).join("_") : ""
            return prmCat
        },
    },
    mounted() {
        console.log("teh cssurd index is mounted", this.onlyEdit, this.viewColumns, this.fetchUrl)
        this.columns = [{ label: "#", field: "index", type: "number" }, ...this.viewColumns]
        if (this.onlyEdit) {
            this.enableEditing(this.onlyEditData)
        } else {
            this.fetchData()
        }
    },
    methods: {
        navigatePage(routeObj) {
            window.location.href = this.$router.resolve(routeObj).href
        },
        async enableCreateForm() {
            this.editData = null

            // for new state
            const showFormOriginal = this.showForm
            this.showForm = false

            setTimeout(() => {
                this.showForm = showFormOriginal
                if (this.showForm && !this.editMode) {
                    this.showForm = false
                } else {
                    this.showForm = true
                }
                this.editMode = false
            }, 0)
        },
        async enableEditing(editItem) {
            this.disableEditing()

            setTimeout(() => {
                this.editMode = true
                this.editData = this.editingFormatter(editItem)
                this.showForm = true
            }, 0)
            window.scroll({ top: 0, behavior: "smooth" })
        },
        async disableEditing(cancelMode) {
            window.scroll({ top: 0, behavior: "smooth" })
            if (this.onlyEdit) {
                if (this.allowGoBack && cancelMode) {
                    this.$router.go(-1)
                }
            } else {
                this.editMode = false
                this.editData = null
                this.showForm = false
            }
        },
        async handleCreateSuccess(result) {
            if (this.onlyEdit) {
                if (this.allowGoBack) {
                    if (this.backRoute) {
                        return this.$router.push(this.backRoute)
                    }
                    this.$router.go(-1)
                }
                return
            }
            if (this.editMode) {
                this.dataItems = this.dataItems.map((item) => {
                    if (item.id == result.id) {
                        return result
                    }
                    return item
                })
            } else {
                this.dataItems.unshift(result)
            }

            this.$emit("created", result)
            if (this.reloadOnSuccess) {
                window.location.reload()
            }
            this.disableEditing()
        },
        async fetchData() {
            this.loading = true
            try {
                const res = await http.get(this.fetchUrl)
                this.dataItems = res.data.result.map((item, index) => ({
                    ...item,
                    index: index + 1,
                }))
                console.log(this.dataItems)
            } catch (err) {
                console.log("error in loading data", err)
            }
            this.initialized = true
            this.loading = false
        },
        async deleteDataItem(id) {
            try {
                if (confirm("Do you really want to delete?")) {
                    await http.delete(`${this.deleteRootUrl}/${id}`)
                    this.$toast.success(this.title + " Deleted Successfully!")
                    this.dataItems = this.dataItems.filter((item) => item.id !== id)
                    this.disableEditing()
                    if (this.reloadOnSuccess) {
                        window.location.reload()
                    }
                }
            } catch (err) {
                console.log("error in deleting " + this.title + " item", err)
                this.$toast.error("Some error occured")
            }
        },
    },
}
</script>

<style lang="scss">
@import "@/assets/variables.scss";

/* ---- CRUD Section Header ---- */
.crud-section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 20px;
}
.crud-page-title {
    font-size: 18px;
    font-weight: 700;
    color: $gray800;
    margin: 0;
    letter-spacing: -0.02em;
}
.crud-add-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 18px;
    border: 1px solid $gray200;
    border-radius: $radiusSm;
    background: white;
    color: $primaryColor;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: all $transitionFast;

    &:hover {
        background: $primaryLight;
        border-color: rgba(0, 94, 137, 0.3);
    }
}

/* ---- Loading & Empty ---- */
.crud-loading {
    display: flex;
    justify-content: center;
    padding: 48px 0;
}
.crud-spinner {
    width: 32px;
    height: 32px;
    border: 3px solid $gray200;
    border-top-color: $primaryColor;
    border-radius: 50%;
    animation: crudSpin 0.7s linear infinite;
}
@keyframes crudSpin { to { transform: rotate(360deg); } }

.crud-empty-state {
    text-align: center;
    padding: 48px 20px;
    color: $gray400;

    i {
        font-size: 36px;
        margin-bottom: 10px;
        display: block;
    }
    p {
        font-size: 14px;
        margin: 0;
        color: $gray500;
    }
}

/* ---- Action Buttons ---- */
.crud-action-group {
    display: flex;
    align-items: center;
    gap: 6px;
}
.crud-action-btn {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 6px 14px;
    border: 1px solid $gray200;
    border-radius: $radiusSm;
    background: white;
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    transition: all $transitionFast;
    white-space: nowrap;

    i {
        font-size: 11px;
    }
}
.crud-btn-edit {
    color: $primaryColor;

    &:hover {
        background: $primaryLight;
        border-color: rgba(0, 94, 137, 0.3);
        color: $primaryDark;
    }
}
.crud-btn-delete {
    color: $danger;

    &:hover {
        background: #fef2f2;
        border-color: rgba(239, 68, 68, 0.3);
        color: #dc2626;
    }
}

/* ---- Legacy compat (for slot buttons) ---- */
.btn-edit,
.btn-delete,
.crud-btn {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 6px 14px;
    border: 1px solid $gray200;
    border-radius: $radiusSm;
    background: white;
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    transition: all $transitionFast;
    text-align: center;
    color: $primaryColor;
}
.btn-edit:hover {
    background: $primaryLight;
    border-color: rgba(0, 94, 137, 0.3);
    color: $primaryDark;
}
.btn-delete {
    color: $danger;
}
.btn-delete:hover {
    background: #fef2f2;
    border-color: rgba(239, 68, 68, 0.3);
    color: #dc2626;
}

/* ---- Datatable Wrapper ---- */
.datatable-wrapper {
    width: 100%;
    overflow-x: auto;
    overflow-y: visible;
    border: 1px solid $gray200;
    border-radius: $radiusMd;
    background: white;
    -webkit-overflow-scrolling: touch;
    box-sizing: border-box;
}
.datatable-wrapper::-webkit-scrollbar {
    height: 6px;
}
.datatable-wrapper::-webkit-scrollbar-track {
    background: transparent;
}
.datatable-wrapper::-webkit-scrollbar-thumb {
    background: $gray300;
    border-radius: 999px;
}
.datatable-wrapper::-webkit-scrollbar-thumb:hover {
    background: $gray400;
}

/* ---- Materialize Datatable Overrides ---- */
.material-table {
    border: none;
    min-width: 100%;
    width: max-content;
    font-family: inherit !important;

    #search-input-container {
        padding: 0;
        label {
            width: 100%;
        }
        input {
            padding: 10px 16px;
            border: 1px solid $gray200 !important;
            border-radius: $radiusSm;
            font-size: 13px;
            font-family: inherit;
            background: $gray50;
            transition: all $transitionFast;
            outline: none;
            box-shadow: none !important;

            &:focus {
                border-color: $primaryColor !important;
                box-shadow: 0 0 0 3px rgba(0, 94, 137, 0.1) !important;
                background: white;
            }
            &::placeholder {
                color: $gray400;
            }
        }
    }

    /* Table header title bar */
    .table-header {
        background: transparent;
        padding: 16px 20px;
        border-bottom: 1px solid $gray100;
        font-size: 15px;
        font-weight: 600;
        color: $gray800;
        letter-spacing: -0.01em;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    /* Table head */
    thead tr {
        border-bottom: 1px solid $gray200;
    }
    thead th {
        background: $gray50 !important;
        color: $gray500 !important;
        font-weight: 600 !important;
        font-size: 11px !important;
        text-transform: uppercase !important;
        letter-spacing: 0.05em !important;
        padding: 12px 20px !important;
        border-bottom: 1px solid $gray200 !important;
        white-space: nowrap;
        position: sticky;
        top: 0;
    }

    /* Table body */
    tbody td {
        padding: 14px 20px !important;
        font-size: 13px !important;
        color: $gray700 !important;
        border-bottom: 1px solid $gray100 !important;
        vertical-align: middle;
    }
    tbody tr {
        transition: background $transitionFast;
    }
    tbody tr:hover {
        background: $gray50 !important;
    }
    tbody tr:last-child td {
        border-bottom: none !important;
    }

    /* Pagination */
    .table-footer {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 8px;
        padding: 12px 20px;
        border-top: 1px solid $gray100;
        font-size: 13px;
        color: $gray500;
    }
}

/* ---- Mobile responsive ---- */
@media (max-width: 768px) {
    .crud-section-header {
        flex-direction: column;
        align-items: flex-start;
    }
    .crud-add-btn {
        width: 100%;
        justify-content: center;
    }
    .crud-action-group {
        flex-wrap: wrap;
    }
}
@media (max-width: 480px) {
    .crud-page-title {
        font-size: 16px;
    }
    .material-table thead th {
        padding: 10px 14px !important;
    }
    .material-table tbody td {
        padding: 10px 14px !important;
    }
}
</style>
